import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private tokenStorage: TokenStorageService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Get token from storage
    const token = this.tokenStorage.getToken();

    if (token) {
      // Check if session is expired
      if (this.tokenStorage.isSessionExpired()) {
        this.tokenStorage.signOut();
        this.router.navigate(['/auth/signin/cover'], {
          queryParams: { expired: 'true' }
        });
        return throwError(() => new Error('Session expired'));
      }

      // Add authorization header
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Update last activity
      this.tokenStorage.updateLastActivity();
    }

    return next.handle(request).pipe(
      catchError((error) => {
        if (error.status === 401) {
          // Unauthorized - clear session and redirect
          this.tokenStorage.signOut();
          this.router.navigate(['/auth/signin/cover']);
        }
        return throwError(() => error);
      })
    );
  }
}
